import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../components/snackbar/snackbar.component'


@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  success: number;

  constructor(
    public snackBar: MatSnackBar) {
  }

  openSnackbar(header: string, paragraph: string, success: number, horizontalPosition: number) {
    this.success = success;
    let h: MatSnackBarHorizontalPosition = 'center';
    if (horizontalPosition != null) {

      switch (horizontalPosition) {
        case 0:
          h = 'left';
          break;
        case 1:
          h = 'center';
          break;
        case 2:
          h = 'right';
          break;
      }
    }

    this.snackBar.openFromComponent(SnackbarComponent, {
      horizontalPosition: h,
      data: {
        success: success, header: header, paragraph: paragraph
      }
      // ,
      // panelClass: ["success_" +this.success]

    });
  }
}
